import angular from 'angular';
import 'script!jquery';
import 'script!jquery.easing';
import 'script!scrolltofixed';
import 'cassie';
import 'script!htmlelement.polyfills';
import 'angular-masonry';
import 'bootstrap';
import WOW from 'wow.js/dist/wow.min';
import './sitemap.xml';


import '../style';

$(document).ready(function (e) {
    $('#test').scrollToFixed();
    $('.res-nav_click').click(function () {
        $('.main-nav').slideToggle();
        return false

    });

});

var wow = new WOW(
    {
        animateClass: 'animated',
        offset: 100
    }
);
wow.init();


$(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
        $('.scrollup').fadeIn();
    } else {
        $('.scrollup').fadeOut();
    }
});
$('.scrollup').click(function () {
    $("html, body").animate({scrollTop: 0}, 1000);
    return false;
});


//jQuery for page scrolling feature - requires jQuery Easing plugin
$(function () {
    $('.navbar-nav li a').bind('click', function (event) {
        var $anchor = $(this);
        var nav = $($anchor.attr('href'));
        if (nav.length) {
            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top
            }, 1500, 'easeInOutExpo');

            event.preventDefault();
        }
    });

});


// WEBPACK FOOTER //
// ./src/app/script-loader.js